import { I9Record } from '../domain/entities/EmployeeRecord';
import { II9FormRecordRepository } from '../ports/outbound/IEmployeeRecordRepository';

export class FetchEmployeeRecordUseCase {
  constructor(private readonly repository: II9FormRecordRepository) { }

  async execute(i9FormId: string): Promise<I9Record> {
    return await this.repository.fetchI9FormRecord(i9FormId);
  }
}
